import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import "../Styles/Legal.css";

function TermsOfUse() {
  return (
    <div className="legal-page">
      <Navbar />

      <section className="page-hero">
        <div className="page-hero-particles">
          <span className="ph-particle ph-particle-1"></span>
          <span className="ph-particle ph-particle-2"></span>
          <span className="ph-particle ph-particle-3"></span>
        </div>
        <div className="container">
          <span className="section-tag">Legal</span>
          <h1 className="page-hero-title">Terms and Conditions</h1>
          <p className="page-hero-subtitle">Please read these terms carefully before using our services.</p>
        </div>
      </section>

      <section className="legal-content section-padding">
        <div className="container">
          <div className="legal-body">
            <p className="legal-updated">Last updated: October 21, 2026</p>

            <h2>1. Who We Are and Acceptance of Terms</h2>
            <p>
              These Terms and Conditions apply to ebenwealth.com and our services. The website and services are operated by Ebenezer Family Group LLC, doing business as Ebenwealth ("Ebenwealth," "we," "our," or "us"). By accessing or using ebenwealth.com, you agree to these Terms and all applicable laws. If you do not agree, please stop using the website.
            </p>

            <h2>2. Services Provided</h2>
            <p>Ebenwealth offers:</p>
            <ul>
              <li>Client solutions, including insurance, retirement planning, and emergency savings strategies.</li>
              <li>Agent opportunities for individuals who want to partner with Ebenezer Family Group LLC.</li>
              <li>Information about specialized programs such as the Kai-Zen Plan.</li>
            </ul>
            <p>
              Services are subject to availability and may be changed or discontinued at any time without prior notice.
            </p>

            <h2>3. Eligibility</h2>
            <p>
              You must be at least 18 years old to use this website or our services. By using the site, you confirm that you meet this requirement.
            </p>

            <h2>4. Use of Website</h2>
            <ul>
              <li>You agree to use the website only for lawful purposes.</li>
              <li>You may not try to gain unauthorized access to the site, our servers, or related systems.</li>
              <li>Content on the site is for informational and educational purposes only and is not financial, legal, or tax advice.</li>
            </ul>

            <h2>5. SMS Text Messaging Program</h2>
            <p><strong>Ebenezer Family Group LLC, doing business as Ebenwealth</strong></p>
            <p>
              <strong>What messages you will get:</strong> if you opt in, you may receive text messages about appointment reminders, policy renewal and review reminders, and occasional birthday greetings.
            </p>
            <p>
              <strong>Consent is optional.</strong> You do not have to agree to receive text messages to use our website or buy any product or service.
            </p>
            <p>
              <strong>How to cancel:</strong> You can cancel the SMS service at any time. Just text "STOP" to +1 763-271-9700. After you send the SMS message "STOP" to us, we will send you an SMS message to confirm that you have been unsubscribed. After this, you will no longer receive SMS messages from us. If you want to join again, just sign up as you did the first time and we will start sending SMS messages to you again.
            </p>
            <p>
              <strong>Help:</strong> If you are experiencing issues with the messaging program, you can reply with the keyword HELP for more assistance, or you can get help directly at <a href="mailto:financialsolutions@ebenwealth.com">financialsolutions@ebenwealth.com</a> or +1 763-271-9700.
            </p>
            <p>Carriers are not liable for delayed or undelivered messages.</p>
            <p>
              <strong>Rates and frequency:</strong> As always, message and data rates may apply for any messages sent to you from us and to us from you. Message frequency varies. If you have any questions about your text plan or data plan, it is best to contact your wireless provider.
            </p>
            <p>
              <strong>Privacy:</strong> If you have any questions regarding privacy, please read our <a href="/privacy-policy">Privacy Policy</a>.
            </p>

            <h2>6. Intellectual Property</h2>
            <p>
              All content, graphics, logos, and materials on ebenwealth.com belong to Ebenezer Family Group LLC or its licensors. Copying, distributing, or modifying them without permission is prohibited.
            </p>

            <h2>7. Third-Party Links</h2>
            <p>
              The website may link to third-party sites (for example, Kai-Zen Plan resources). Ebenezer Family Group LLC is not responsible for the content, accuracy, or practices of those sites.
            </p>

            <h2>8. Limitation of Liability</h2>
            <ol>
              <li>Financial decisions made based on information from this site are made at your own discretion and risk.</li>
              <li>Ebenezer Family Group LLC is not liable for any direct, indirect, incidental, or consequential damages arising from your use of this website or reliance on its content.</li>
            </ol>

            <h2>9. Privacy</h2>
            <p>
              Your use of the website is also governed by our <a href="/privacy-policy">Privacy Policy</a>, which explains how personal information is collected, used, and protected.
            </p>

            <h2>10. Payment and Fees</h2>
            <p>
              Where applicable, services may involve fees or premiums (for example, insurance products). All payments must follow the terms agreed between you and Ebenezer Family Group LLC.
            </p>

            <h2>11. Termination</h2>
            <p>
              We may suspend or end access to the website at our discretion, without prior notice, for any violation of these Terms.
            </p>

            <h2>12. Governing Law</h2>
            <p>
              These Terms are governed by the laws of the State of Minnesota, USA, where Ebenezer Family Group LLC is headquartered.
            </p>

            <h2>13. Contact Us</h2>
            <p>For questions about these Terms, contact:</p>
            <div className="legal-contact-box">
              <p><strong>Ebenezer Family Group LLC, doing business as Ebenwealth</strong></p>
              <p>6160 Summit Dr N,<br/>Suite #145,<br/>Brooklyn Center, MN 55429</p>
              <p>Phone: <a href="tel:+17632719700">+1 763-271-9700</a></p>
              <p>Email: <a href="mailto:financialsolutions@ebenwealth.com">financialsolutions@ebenwealth.com</a></p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default TermsOfUse;
